import { Component, Prop, h, State, Host } from '@stencil/core';
import '../header-component/header-component';
import '../loader-component/loader-component'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

/**
#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/tabs-component.PNG)

#### Content Type
nypwebc_ct_tabs
*/


@Component({
  tag: 'tabs-component',
  styleUrl: 'tabs-component.css',
  scoped: true
})
export class TabsComponent {

  /**
   *Required - Unique ID.
   */
  @Prop() componentid: string = "comp-id";

  /**
  *Required - List Name.
  */
  @Prop() listname: string = "ListName";

  /**
  *Required - Relative to the root site. no trailing slash. for ex: /hr/pm
  */
  @Prop() webpath: string = "/";

  /**
  *Required - if header attribute is true
  */
  @Prop() sectiontitle: string = "Section Title";

  /**
  *Required - if header attribute is true
  */
  @Prop() titleiconurl: string = "";

  /**
  *Optional - To show/hide header. default is true
  */
  @Prop() header: boolean = true;

  /**
 *Optional - vertical scroll bar
 */
  @Prop() verticalscroll: boolean = false;

  /**
 *Optional - vertical scroll bar height
 */
  @Prop() verticalscrollheight: number = 200;


  /**
   *Optional - image location - left, right,top or bottom
   */
  @Prop() imagepos: string = "none";

   /**
   *Optional - image col span  if image pos is  left or  right. default is 4
   */
   @Prop() imagecolspan: number = 4;

  /**
*Optional - header background color
*/
  @Prop() headerbgcolor: string = "white"

  /**
  *Optional -header text color
  */
  @Prop() headertextcolor: string = "black"
  /**
  *Optional -header border bottom css
  */
  @Prop() headerborderbottom: string = "1px solid #CE2127"

  /**
 *Optional - To show see all link
 */
  @Prop() seeall: boolean = false;
  /**
 *Optional - see All link
 */
  @Prop() seeallurl: string = "";

  /**
*Optional - see All link Title
*/
  @Prop() seealltitle: string = "See All";
  /**
*Optional - is it SP Online site
*/
  @Prop() online: boolean = false;

  /**
   *Required - site url if its sp online site
   */
  @Prop() siteurl: string = "";

  @State() items: []
  @State() isLoading: boolean = true;

  componentDidLoad() {
    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;
    // let siteUrl: string = "";

    // if (this.online) {
    //   siteUrl = this.siteurl + this.webpath
    // }
    // else {
    //   siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    // }

    let siteUrl: string = "";
    if ((window as any)._spPageContextInfo != null) {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    }
    else {
      let domain = new URL(window.location.href)
      siteUrl = domain.origin + this.webpath
    }
    const filter = "nypwebc_Active eq 1";
    return fetch(siteUrl + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,nypwebc_ItemOrder,nypwebc_Url,nypwebc_ImageUrl,nypwebc_Body&$filter=" + filter + "&$orderby=nypwebc_ItemOrder&", { headers: { "Accept": "application/json; odata=verbose" } })

      .then(response => response.json())
      .then(data => {
        this.items = data.d.results;
        this.isLoading = false;
      });
  }


  getTabs = () => {

    const tabsArray = []
    this.items.forEach((item: any, index: any) => {
      let target = '#Tabs' + this.componentid + item.ID
      let ids = this.componentid + item.ID +"-Tab"

      if (index === 0) {

        tabsArray.push(
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id={ids} data-bs-toggle="tab" data-bs-target={target} type="button" role="tab" aria-controls={item.Title} aria-selected="true">
              {item.Title}</button>
          </li>

        )
      }
      else {
      tabsArray.push(
        <li class="nav-item" role="presentation">
          <button class="nav-link" id={ids} data-bs-toggle="tab" data-bs-target={target} type="button" role="tab" aria-controls={item.Title} aria-selected="true">
            {item.Title}</button>
        </li>

      )
      }

    })
    return tabsArray

  }

  getTabsContents = () => {

    const contentsArray = []
    
    this.items.forEach((item: any,index:any) => {
      let altImage = item.Title + " image"
      let activeclass=""
      // let target ="Tabs"+ this.componentid + item.ID
      let target = 'Tabs' + this.componentid + item.ID
      
      if (index === 0)
      {
        activeclass="tab-pane fade show active"
      }
      else
      {
         activeclass="tab-pane fade"
      }

      let bodystring: string = ""
      let domNode: any;
      let bodyexist: boolean = false

      if (item.nypwebc_Body != null) {

        bodyexist = true;
        let parser = new DOMParser();
        bodystring = item.nypwebc_Body
        domNode = parser.parseFromString(bodystring, "text/html");
        const img = domNode.querySelectorAll("img");
        const tables = domNode.querySelectorAll("table");
        const videos = domNode.querySelectorAll("video");

        for (let i = 0; i < img.length; i++) {
          img[i].classList.add("sc-tabs-component", "img-fluid", "rounded");
        }

        if (item.nypwebc_ImageUrl) {

          if (this.imagepos === "top") {
            contentsArray.push(

              <div key={item.ID} class={activeclass} id={target} role="tabpanel" aria-labelledby={item.Title}>

                <div class="col-md-12"  >
                  <a href={item.nypwebc_Url} target= "_blank"  data-interception="off" >
                    <img id="about-image" src={item.nypwebc_ImageUrl} class="img-fluid rounded mx-auto d-block " alt={altImage} /></a>
                </div>
                <div class="col-md-12" >
                  {bodyexist ?
                    <p > <div class="raw-html-style" innerHTML={domNode.body.innerHTML} /> </p>
                    :
                    <div></div>
                  }
                </div>

              </div>

            )
          }
          else if (this.imagepos === "bottom") {
            contentsArray.push(
              <div key={item.ID} class={activeclass} id={target} role="tabpanel" aria-labelledby={item.Title}>

                <div class="col-md-12">
                  {bodyexist ?
                    <p > <div class="raw-html-style" innerHTML={domNode.body.innerHTML} /> </p>
                    :
                    <div></div>
                  }
                </div>

                <div class="col-md-12"  >
                  <a href={item.nypwebc_Url} target= "_blank"  data-interception="off" >
                    <img id="about-image" src={item.nypwebc_ImageUrl} class="img-fluid rounded mx-auto d-block " alt={altImage} /></a>
                </div>
              </div>

            )
          }

          else if (this.imagepos === "left") {
            let imagestyle = "col-md-" + this.imagecolspan+" img-fluid rounded  mx-auto d-block  float-md-start"
            contentsArray.push(

              <div key={item.ID} class={activeclass} id={target} role="tabpanel" aria-labelledby={item.Title}>
                <a href={item.nypwebc_Url}  target= "_blank"  data-interception="off" >
                  <img id="about-image" src={item.nypwebc_ImageUrl} class={imagestyle} alt={altImage} /></a>


                {bodyexist ?
                  <p > <div class="raw-html-style" innerHTML={domNode.body.innerHTML} /> </p>
                  :
                  <div></div>
                }
              </div>

            )
          }
          else if (this.imagepos === "right") {
            let imagestyle = "col-md-" + this.imagecolspan+" img-fluid rounded  mx-auto d-block  float-md-end"
            contentsArray.push(
              <div key={item.ID} class={activeclass} id={target} role="tabpanel" aria-labelledby={item.Title}>
                <a href={item.nypwebc_Url}  target= "_blank"  data-interception="off">
                  <img id="about-image" src={item.nypwebc_ImageUrl} class={imagestyle} alt={altImage} /></a>

                {bodyexist ?
                  <p > <div class="raw-html-style" innerHTML={domNode.body.innerHTML} /> </p>
                  :
                  <div></div>
                }
              </div>

            )
          }
          else {
            contentsArray.push(
              <div key={item.ID} class={activeclass} id={target} role="tabpanel" aria-labelledby={item.Title}>
                <div>
                  {bodyexist ?
                    <p > <div class="raw-html-style" innerHTML={domNode.body.innerHTML} /> </p>
                    :
                    <div></div>
                  }
                </div>
              </div>

            )

          }
        }
        else {
          contentsArray.push(
            <div key={item.ID} class={activeclass} id={target} role="tabpanel" aria-labelledby={item.Title}>
              <div>
                <p> <div class="raw-html-style" innerHTML={domNode.body.innerHTML} /> </p>
              </div>
            </div>

          )
        }
      }
    })
    return contentsArray
  }

  render() {

    let style = {}
    let styleWithHeader = {}
    let parentstyle = {}
    if (this.verticalscroll) {
      style = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }
      styleWithHeader = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }

      parentstyle = {
        minHeight: (this.verticalscrollheight + 20) + "px",
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        paddingBottom: "10px"
      }
    }
    else {
      style = {
      }
      parentstyle = {
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        paddingBottom: "10px"
      }
    }


    return (
      this.isLoading ? <loader-component />
        :
        this.header  && this.items.length > 0 ?

          <div id={this.componentid}>
            <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl} seeall={this.seeall} seealltitle={this.seealltitle} seeallurl={this.seeallurl} headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />
            <div class="row gx-0 justify-content-center" style={parentstyle} >
              <div style={styleWithHeader} >
                <ul class="nav nav-tabs" id={this.componentid + "Tab"} role="tablist">
                  {this.getTabs()}
                </ul>
                <div class="tab-content" id={this.componentid +"TabContent"}>
                  {this.getTabsContents()}
                </div>
              </div>
            </div>
          </div>
          :
          <div id={this.componentid} class="row gx-0 justify-content-center" style={parentstyle} >
            <div style={style}  >
              <ul class="nav nav-tabs" id={this.componentid + "Tab"} role="tablist">
                {this.getTabs()}
              </ul>
              <div class="tab-content" id={this.componentid +"TabContent"}>
                {this.getTabsContents()}
              </div>
            </div>
          </div>
    )

  }
}
